var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import JSQuestionnaireHeader from "../../../molecules/jsQuestionnaireHeader/jsquestionnaireHeader";
import Button from "../../../atoms/button/button";
import { LogoutAction } from "../../../../redux/actions/authentication";
import "../../../organisms/jsQuestionnaire/jsQuestionnaire.css";
import "../../../molecules/jsQuestionnaireFooter/jsQuestionnaireFooter.css";
/**
 * The Questionnaire Saved Page
 * Shown after "Save and Continue Later", confirming the answers given so far
 * are saved and letting the user log out or carry on.
 * @returns
 */
function QuestionnaireSaved() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var handleLogout = function () {
        navigate("/login");
        dispatch(LogoutAction());
    };
    return (_jsxs("div", __assign({ className: "questionnaire px-4 py-4 md:px-8 md:py-10 lg:px-16 lg:py-12 sm:max-w-2xl md:max-w-6xl mx-auto" }, { children: [_jsx(JSQuestionnaireHeader, { title: "Your progress has been saved", content: "The answers you have given so far are saved. You can log out or close this page now. When you log back in, your questionnaire will open at the page you left.", classname: "", hideProgress: true }), _jsx("hr", { className: "hr-size" }), _jsxs("div", __assign({ className: "flex" }, { children: [_jsx(Button, { children: "Log Out", className: "back-btn flex-auto", primary: false, onClick: handleLogout }), _jsx(Button, { children: "Continue Questionnaire", className: "continue-btn flex-auto", onClick: function () { return navigate("/questionnaire/resume"); } })] }))] })));
}
export default QuestionnaireSaved;
